import { useCallback } from 'react';
import { createContextStore } from './createContextStore';

export function createGlobalResource<T>(identifier?: string) {
    const { withStore, useStoredValue, useStoreValue } = createContextStore<T>(identifier);

    function useUpdateGlobalResource<Args extends unknown[]>(updater: ((...args: Args) => T) | ((...args: Args) => Promise<T>)) {
        const update = useStoreValue();

        return useCallback((...args: Args) => {
            update((() => updater(...args)) as (() => T) | (() => Promise<T>));
        }, [update, updater]);
    }

    function useGlobalResource(defaultValue?: T) {
        const value = useStoredValue();
        return value ?? defaultValue;
    }

    return { withGlobalResource: withStore, useUpdateGlobalResource, useGlobalResource };
}
